import { COUNTRIES } from "@/package/global-constants/countries-list";

export function getCurrentCountryCode(): "GH" | "UZ" | "KG" {
  switch (window.location.origin) {
    case import.meta.env.VITE_FRONTEND_URL_GH:
      return "GH";
    case import.meta.env.VITE_FRONTEND_URL_UZ:
      return "UZ";
    default:
      return "KG";
  }
}

export function getCurrentCountry() {
  return COUNTRIES[getCurrentCountryCode()];
}

export function getCurrentCountryCurrency() {
  return COUNTRIES[getCurrentCountryCode()].currency;
}

export function getCurrentCountryPassport() {
  return COUNTRIES[getCurrentCountryCode()].auth.passportUrl;
}
